import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import Layout from "../components/Layout";
import { LOGO_URL, errorMessage } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const redirect = params.get("redirect") || "/";
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const user = await login(username, password);
      toast.success(`Welcome back, ${user.full_name.split(" ")[0]}!`);
      if (user.role === "admin") nav("/admin");
      else nav(redirect);
    } catch (e) { toast.error(errorMessage(e)); }
    finally { setSubmitting(false); }
  };

  return (
    <Layout>
      <section className="page-section min-h-[80vh] flex items-center" data-testid="login-page">
        <div className="max-w-md w-full mx-auto px-4">
          <div className="text-center mb-8">
            <img src={LOGO_URL} alt="Sugary Sweet" className="h-20 mx-auto mb-3 logo-white drop-shadow-lg" />
            <h1 className="font-display font-extrabold text-3xl md:text-4xl text-white drop-shadow-lg">Welcome Back</h1>
            <p className="text-white/90 mt-2 text-sm">Log in to place an order and earn rewards.</p>
          </div>
          <form onSubmit={submit} className="bg-white rounded-3xl shadow-2xl p-6 md:p-8 space-y-4">
            <label className="block">
              <span className="text-xs uppercase tracking-widest font-bold text-[#4B5563]">Email</span>
              <input type="text" inputMode="email" autoComplete="username" className="input-base mt-1" value={username} onChange={e => setUsername(e.target.value)} placeholder="you@example.com" required data-testid="login-username" />
            </label>
            <label className="block">
              <span className="text-xs uppercase tracking-widest font-bold text-[#4B5563]">Password</span>
              <input type="password" className="input-base mt-1" value={password} onChange={e => setPassword(e.target.value)} required data-testid="login-password" />
            </label>
            <button type="submit" disabled={submitting} className="btn-pink w-full" data-testid="login-submit-btn">
              {submitting ? "LOGGING IN..." : "LOG IN"}
            </button>
            <p className="text-center text-sm text-[#4B5563]">
              No account?{" "}
              <Link to={`/signup${redirect !== "/" ? `?redirect=${encodeURIComponent(redirect)}` : ""}`} className="text-[#FF1F87] font-bold" data-testid="login-signup-link">Sign up</Link>
            </p>
          </form>
        </div>
      </section>
    </Layout>
  );
}
